function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.000000,1363.000000) scale(0.100000,-0.100000)",
  fill: "#000000",
  stroke: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5840 11429 c-241 -21 -470 -72 -910 -204 -602 -180 -975 -243 -1455 -246 l-200 -1 125 -20 c157 -24 649 -103 1010 -162 659 -107 1174 -155 1525 -143 168 5 208 16 293 74 108 74 164 182 165 318 0 126 -49 230 -145 306 -97 76 -201 96 -408 78z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10890 11430 c-258 -20 -485 -71 -980 -221 -519 -158 -866 -217 -1335 -228 l-260 -6 155 -23 c85 -13 403 -63 705 -112 592 -96 832 -130 1075 -154 328 -33 746 -46 850 -26 86 16 165 57 219 114 85 91 117 181 108 303 -13 171 -132 309 -302 348 -64 16 -87 16 -235 5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2680 8600 l0 -1989 94 -3 95 -3 -745 -195 c-410 -107 -749 -197 -754 -200 -7 -4 -12 -734 -17 -2002 l-6 -1995 164 -8 c90 -4 3222 -8 6960 -9 l6796 -3 8 2664 c4 1465 6 2666 4 2667 -2 2 -1005 -259 -2229 -580 -1224 -321 -2232 -583 -2240 -583 -13 -1 -15 69 -12 585 l3 586 -23 -8 c-40 -12 -2191 -574 -2200 -574 -4 0 -8 819 -8 1820 l0 1820 -595 0 -595 0 0 -1974 c0 -1240 -4 -1977 -10 -1981 -10 -6 -955 -255 -970 -255 -6 0 -7 212 -3 576 6 571 6 576 -13 570 -17 -5 -2404 -630 -2486 -651 l-28 -7 0 1861 0 1861 -595 0 -595 0 0 -1990z"
}));

function SvgCompany(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1672.000000pt",
    height: "1363.000000pt",
    viewBox: "0 0 1672.000000 1363.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany);
export default __webpack_public_path__ + "static/media/company.ab4834bc.svg";
export { ForwardRef as ReactComponent };